import { createShouldForwardPropBlockList, deepMerge } from "@components/common/utils/helper";
import { type OptionGroupProps } from "./option-group";
import { getPadding } from "../option.styles.utils";
import styled from "styled-components";

type LabelProps = Pick<OptionGroupProps, "size">;

export const Wrapper = styled("div")(({ theme }) => ({
    borderBottomWidth: theme.borderWidth.DEFAULT,
    borderStyle: "solid",
    borderBottomColor: theme.colors.gray[200],
    paddingBottom: theme.spacing[2],
    marginBottom: theme.spacing[2],
    "&:last-child": {
        borderBottom: "none",
        paddingBottom: 0,
        marginBottom: 0,
    },
}));

export const Label = styled("div").withConfig({
    shouldForwardProp: createShouldForwardPropBlockList(["size"]),
})<LabelProps>(({ size, theme }) => ({
    lineHeight: "22px",
    fontSize: theme.fontSize["3xs"],
    paddingLeft: theme.spacing[3.5],
    paddingRight: theme.spacing[3.5],
    paddingBottom: theme.spacing[2],
    color: theme.colors.gray[600],
    ...deepMerge(getPadding(size, theme)),
}));
